
// Common
import HTMLDsbElement from 'https://stmaadev.blob.core.windows.net/stc-maa-dev-fw-site/scripts/scriptloader/HTMLDsbElement/class-HTMLDsbElement-fetch,mustache-v1.1.0.es.js';
import widgetsPart from "../parts/part-widgets.js";

//CSS
import _CSS from '../../dest/css/dsb-content.min.css';

export default class extends HTMLDsbElement {
  constructor() {
    super({'component_name':'dsb-content','css':_CSS,'onReady':function(element,_this){
      _this.dsb.helpers.add('content','processWidgets',widgetsPart(_this.dsb));
    }});
    this._settings=false;
    this._data_sources = '';
  }


  async _render()
  {
    let _this = this;

    if(Array.isArray(this.data) && this.data.length>0)
    {
      for(let this_data of this.data)
      {
        if(typeof this_data === 'object' && this_data!==null)
        {
         let widgets = this.dsb.helpers.run('content','processWidgets',[this_data]);
         if(widgets instanceof HTMLElement)
         {
          if(this.dsb.state.is('loading'))
          {
            this.dsb.state.set('adding-content');
          }
          this.dsb.element.append(widgets);
         }
        }
      }
    }

  }
}

